'use client';

import { c as _c } from "react/compiler-runtime";
import '@/global.css';
import classnames from 'classnames';
import { CookiesProvider, SchemesProvider } from '@personly/libs-providers';
import Body from '@/components/body';
import ErrorTitle from '@/components/error-title';
import ErrorView from '@/views/error-view';
import Html from '@/components/html';
import locales from '@cache/locales.json';
import schemes from '@cache/schemes.json';
const hostname = process.env.NEXT_PUBLIC_SELF_HOSTNAME!;
const className = classnames('flex', 'flex-1', 'min-h-screen', 'items-center', 'justify-center');
const params = {
  locale: locales.defaultLocale
};
const GlobalError = () => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <head><link rel="stylesheet" href="/theme.css" /></head>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Html locale={params.locale}>{t0}<Body><main className={className}><CookiesProvider cookies={t1} cookieTypes={t2} hostname={hostname}><SchemesProvider schemes={schemes}><ErrorView name="personly" schemes={schemes.schemes}><ErrorTitle>File not Found</ErrorTitle></ErrorView></SchemesProvider></CookiesProvider></main></Body></Html>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default GlobalError;